/**
 * @file /resorts route definitions.
 */
import React from 'react';
import { Route } from 'react-router-dom';

import RedirectWithStatus from '../components/routing/RedirectWithStatus';
import ResortsLandingView from '../apps/pro/views/Welcome/ResortsLanding';
import ACCOUNT_ROLES from '../constants/account-roles';
import RequirePermissions from '../components/routing/RequirePermissions';
import { getRoleBasename } from '../util/role-definitions';

const basename = getRoleBasename(ACCOUNT_ROLES.RESORT_ADMIN);
const RequireAccount = RequirePermissions(
  ['account-complete'],
  ACCOUNT_ROLES.RESORT_ADMIN,
);

const routes = [
  {
    path: `/app/${basename}/welcome`,
    exact: true,
    component: RequireAccount(ResortsLandingView),
  },
  {
    path: `/app/${basename}`,
    component: () => (
      <Route
        path={`/app/${basename}`}
        render={({ match }) => (
          <RedirectWithStatus status={301} to={`${match.url}/welcome`} />
        )}
      />
    ),
  },
];

export default routes;
